import { axiosInstance } from "./axiosInstance";

type DownloadProposalExcelParams = {
  status: string;
  searchTerm?: string;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
};

export const downloadProposalExcel = async (
  params: DownloadProposalExcelParams
): Promise<Blob> => {
  try {
    const response = await axiosInstance.get("/api/proposal-excel", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao baixar Excel de propostas:", error);
    throw error;
  }
};
